import { Type } from 'class-transformer';

export class VendorDisbursementSearchResultDto {
    vendor: string;
    paymentNumber: string;
    paymentAmount: number;
    @Type(() => Date)
    paymentDate: Date;
    paymentMethod: string;
    cleared: boolean;
    @Type(() => Date)
    dateCleared: Date;
    communityId: number;
    community: string;
    location: string;
    managementCompany: string;
    managementCompanyId: number;
    bankAccount: string;
    bankName: string;
    accountNumber: string;
    paymentId: number;
    vendorCode: string;
}
